const BPS_STAGES = ['local', 'staging', 'rc', 'production'] as const;

export type BpsStage = (typeof BPS_STAGES)[number];

export type FeatureKey = 'pathBuilder';

export function parseStage(value: string | undefined): BpsStage | undefined {
  const normalized = value?.trim().toLowerCase();
  if (normalized && (BPS_STAGES as readonly string[]).includes(normalized)) {
    return normalized as BpsStage;
  }
  return undefined;
}

/** Deploy target for this build. Set via `VITE_STAGE` in env files and CI. */
export function getBpsStage(): BpsStage {
  const configuredStage = parseStage(import.meta.env.VITE_STAGE);
  if (configuredStage) {
    return configuredStage;
  }
  return import.meta.env.DEV ? 'local' : 'production';
}

function isPathBuilderEnabled(): boolean {
  const stage = getBpsStage();
  return stage === 'staging' || stage === 'rc';
}

/**
 * Compile-time feature gates keyed by deploy stage (and future per-feature overrides).
 * Keep boolean on/off flags here. Per-stage secrets or config values (for example site
 * access passwords) belong in dedicated env-backed modules, not in `features`.
 */
export const features = {
  get pathBuilder(): boolean {
    return isPathBuilderEnabled();
  },
} as const;

export function isFeatureEnabled(feature: FeatureKey): boolean {
  return features[feature];
}
